export default class Alert {
	defaults = {
		delay: 4000,
	};

	container = document.createElement('div');

	constructor(msg, opts) {
		this.options = { ...this.defaults, ...opts };
		this.container.classList.add('uw-alert');
		const closeButton = document.createElement('button');
		closeButton.setAttribute('type', 'button');
		closeButton.classList.add('close');
		closeButton.textContent = 'X';
		closeButton.setAttribute('aria-label', 'Close');
		closeButton.addEventListener('click', () => {
			this.container.classList.remove('show-alert');
			setTimeout(() => {
				this.container.remove();
			}, 700);
		});
		const span = document.createElement('span');
		span.textContent = msg;
		this.container.append(closeButton);
		this.container.append(span);

		document.body.append(this.container);

		setTimeout(() => {
			this.container.classList.add('show-alert');
		}, 100);

		if (this.options.delay >= 0) {
			setTimeout(() => {
				this.container.classList.remove('show-alert');
			}, this.options.delay);
		}
	}
}
